var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Scratch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9dbd2",
    d: "M50,12c-20.987,0-38,17.013-38,38s17.013,38,38,38s38-17.013,38-38S70.987,12,50,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M78,13c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S78.552,13,78,13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M84,12c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S86.209,12,84,12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M14,24c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S15.105,24,14,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M85,77c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S86.105,77,85,77z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M26,82c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S27.105,82,26,82z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.483,74.034c-1.371,0-2.483,1.112-2.483,2.483S68.112,79,69.483,79 s2.483-1.112,2.483-2.483S70.854,74.034,69.483,74.034z M19,45c-0.552,0-1,0.448-1,1s0.448,1,1,1c0.552,0,1-0.448,1-1 S19.552,45,19,45z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M86,30c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S86.552,30,86,30z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80,54c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S81.105,54,80,54z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.41,
    cy: 71.857,
    r: 4,
    fill: "#fbcd59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcef",
    d: "M42.266,79.498c-6.404,0-11.594-5.191-11.594-11.594V57.188c-0.039-0.839-0.02-1.639,0.046-2.379 c0.193-2.153,0.964-4.12,2.149-5.757c-1.42-4.331-1.024-8.253-0.806-9.66c1.184-7.906,7.037-15.658,16.119-16.112 c2.098-1.793,4.841-2.85,7.817-2.774c6.401,0.159,11.461,5.477,11.303,11.879c-0.001,0.048-0.122,4.983-0.122,11.773 c0,1.197-0.182,2.352-0.52,3.442c1.773,2.753,2.508,5.654,2.635,7.984c0.195,2.451,0.099,8.142-4.024,13.145 c-2.226,2.702-6.347,6.019-13.331,6.474c-0.234,0.014-0.464,0.027-0.693,0.037C49.119,77.839,45.886,79.498,42.266,79.498z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: "M42.266,79.498c-6.404,0-11.594-5.191-11.594-11.594V57.188c-0.039-0.839-0.02-1.639,0.046-2.379 c0.193-2.153,0.964-4.12,2.149-5.757c-1.42-4.331-1.024-8.253-0.806-9.66c1.184-7.906,7.037-15.658,16.119-16.112 c2.098-1.793,4.841-2.85,7.817-2.774c6.401,0.159,11.461,5.477,11.303,11.879c-0.001,0.048-0.122,4.983-0.122,11.773 c0,1.197-0.182,2.352-0.52,3.442c1.773,2.753,2.508,5.654,2.635,7.984c0.195,2.451,0.099,8.142-4.024,13.145 c-2.226,2.702-6.347,6.019-13.331,6.474c-0.234,0.014-0.464,0.027-0.693,0.037C49.119,77.839,45.886,79.498,42.266,79.498z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef9922",
    d: "M62.839,41c-0.005,0.995-0.008,2.052-0.008,3.158c0,1.492-0.452,2.883-1.229,4.039 c2.446,2.606,3.305,5.624,3.364,7.83c0.12,1.752,0.054,6.167-3.051,9.937c-1.681,2.041-4.826,4.547-10.257,4.9 c-0.985,0.062-1.91,0.061-2.778,0.007c-1.133,2.524-3.668,4.28-6.613,4.28c-4.002,0-7.246-3.244-7.246-7.246v-10.96 c-0.036-0.834,0.003-1.452,0.029-1.748c0.192-2.15,1.308-4.004,2.928-5.194c-2.313-4.324-1.814-8.761-1.611-9.996 c0.947-6.242,5.491-12.729,13.282-12.383c0.116,0.006,0.231,0.011,0.345,0.02c1.364-1.749,3.527-2.866,5.897-2.79 c4,0.099,7.163,3.424,7.064,7.423C62.952,32.317,62.866,35.827,62.839,41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M51.656,70.863 c-0.985,0.062-1.91,0.061-2.778,0.007c-1.133,2.524-3.668,4.28-6.613,4.28c-4.002,0-7.246-3.244-7.246-7.246v-10.96 c-0.036-0.834,0.003-1.452,0.029-1.748c0.192-2.15,1.308-4.004,2.928-5.194c-2.313-4.324-1.814-8.761-1.611-9.996 c0.947-6.242,5.491-12.729,13.282-12.383c0.116,0.006,0.231,0.011,0.345,0.02c1.364-1.749,3.527-2.866,5.897-2.79"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M62.83,43.875 c0,0.094,0,0.188,0,0.282c0,1.492-0.452,2.883-1.229,4.039c2.446,2.606,3.305,5.624,3.364,7.83 c0.12,1.752,0.054,6.167-3.051,9.937c-1.412,1.713-3.854,3.755-7.815,4.574"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#472b29",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M58.224,25.298 c2.826,1.045,4.809,3.798,4.73,6.978c-0.001,0.041-0.084,3.438-0.113,8.474"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcef",
    d: "M42.266,69.353c-0.8,0-1.449-0.648-1.449-1.449v-11.16c-0.03-0.593,0.001-0.981,0.006-1.03 c0.069-0.771,0.71-1.369,1.508-1.319c0.775,0.034,1.385,0.672,1.385,1.448v0.828c0.057,0.944,0.34,2.654,1.561,3.894 c1.228,1.247,3.193,1.792,5.816,1.622c1.87-0.122,3.252-0.71,4.11-1.752c1.33-1.615,1.083-3.882,1.08-3.905 c-0.013-0.099-0.016-0.201-0.007-0.301c0.002-0.106,0.036-3.368-6.465-4.485c-2.762-0.474-4.848-1.694-6.2-3.627 c-2.218-3.169-1.543-7.067-1.514-7.231c0.387-2.654,2.407-7.672,7.275-7.471c2.194,0.105,3.734,0.916,4.826,2.083 c0.032-2.136,0.063-3.411,0.064-3.436c0.02-0.798,0.701-1.435,1.485-1.412c0.8,0.02,1.433,0.685,1.412,1.486 c-0.001,0.05-0.125,5.091-0.125,12.025c0,0.771-0.604,1.408-1.374,1.448c-0.776,0.067-1.437-0.532-1.517-1.299 c-0.442-4.269-1.117-7.818-4.91-7.998c-3.465-0.215-4.245,4.836-4.277,5.048c-0.01,0.057-0.293,1.756,0.266,3.527 c0.704,2.226,2.366,3.535,5.08,4.003c8.456,1.452,8.874,6.386,8.869,7.401c0.059,0.655,0.205,3.642-1.731,5.991 c-1.387,1.683-3.459,2.625-6.159,2.801c-3.208,0.205-5.743-0.47-7.566-2.013v4.838C43.715,68.705,43.066,69.353,42.266,69.353z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Scratch);
export default __webpack_public_path__ + "static/media/icons8-scratch.d47aa14ee99c707542576caf9bd6a790.svg";
export { ForwardRef as ReactComponent };